import { useEffect, useState } from "react";
import { getUser } from "@/lib/auth";

export const useAuth = () => {
  const [user, setUser] = useState(getUser());

  useEffect(() => {
    const sync = () => setUser(getUser());
    window.addEventListener("relayrigs-auth-change", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("relayrigs-auth-change", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return user;
};
